module.exports = __webpack_public_path__ + "img/rimbaud.eb858c10.png";